module.exports = __webpack_public_path__ + "static/head-617efbb03e7fe8eb5bd8c3d6eb0a96c4.jpg";